import { Dispatch, SetStateAction, useEffect, useRef } from 'react';
import styles from './EpAuthenticatorGroup.module.scss';
import { EpAuthenticator } from '../EpAuthenticator';

interface EpAuthenticatorGroupProps {
  callBackFunction: (token: string) => void;
  setToken: Dispatch<SetStateAction<string>>;
  token: string;
  tokenLength?: number;
}

export default function EpAuthenticatorGroup({
  callBackFunction,
  setToken,
  token,
  tokenLength = 6,
}: EpAuthenticatorGroupProps) {
  const inputsRef = useRef<HTMLInputElement[]>([]);

  const handleInputChange = (
    index: number,
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;
    if (/^\d*$/.test(value)) {
      setToken((prevToken) => {
        const newToken = prevToken.split('');
        newToken[index] = value;
        return newToken.join('');
      });
      if (value.length === 1 && index < inputsRef.current.length - 1) {
        inputsRef.current[index + 1].focus();
      }
    }
  };

  useEffect(() => {
    if (token.length === tokenLength) callBackFunction(token);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const handleInputKeyDown = (
    index: number,
    event: React.KeyboardEvent<HTMLInputElement>,
  ) => {
    if (event.key === 'Backspace' && !event.currentTarget.value) {
      if (index > 0) {
        inputsRef.current[index - 1].focus();
      }
    }
  };

  return (
    <div className={styles['ep-authenticator-group']}>
      {Array.from({ length: tokenLength }, (_, index) => (
        <EpAuthenticator
          inputId={`authenticator-field--${index}`}
          inputName={`authenticator-field--${index}`}
          inputSize="md"
          key={index}
          value={token[index] || ''}
          authenticatorId={`authenticator-field--${index}`}
          authenticatorName="authenticator-field"
          authenticatorMaxValue={1}
          customClasses="form-control ep-input"
          onChange={(event) => handleInputChange(index, event)}
          authenticatorRef={(ref) => (inputsRef.current[index] = ref as HTMLInputElement)
          }
          onKeyDown={(event) => handleInputKeyDown(index, event)}
        />
      ))}
    </div>
  );
}
